"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.isempty"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _common = require("../../common");

var _components = require("../../../../../common/components");

require("../styles/_wizard-asset-files-step.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NEW_GROUP = function NEW_GROUP() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "".concat(Date.now());
  return {
    name: name,
    key: key,
    assetIds: [],
    notes: void 0
  };
};

var INITIAL_GROUPS = function INITIAL_GROUPS(initialGroups) {
  return !(0, _lodash2.default)(initialGroups) ? initialGroups : [NEW_GROUP()];
};

var WizardAssetFilesStep = /*#__PURE__*/function (_Component) {
  _inherits(WizardAssetFilesStep, _Component);

  function WizardAssetFilesStep(props) {
    var _this;

    _classCallCheck(this, WizardAssetFilesStep);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WizardAssetFilesStep).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateInputField", (0, _lodash.default)(function (fieldName) {
      return function (result) {
        _this.setState(_defineProperty({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (assetId) {
      return function () {
        _this.setState({
          modalVisible: true,
          modalAssetId: assetId
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modalVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addGroup", function () {
      _this.setState(function (_ref) {
        var groups = _ref.groups;
        return {
          groups: [].concat(_toConsumableArray(groups), [NEW_GROUP()])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateGroup", function (index) {
      return function (newGroup) {
        _this.setState(function (_ref2) {
          var groups = _ref2.groups;

          var newGroups = _toConsumableArray(groups);

          newGroups[index] = newGroup;
          return {
            groups: newGroups
          };
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "deleteGroup", function (index) {
      return function () {
        _this.setState(function (_ref3) {
          var groups = _ref3.groups;

          var newGroups = _toConsumableArray(groups);

          newGroups.splice(index, 1);
          return {
            groups: newGroups
          };
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaveAndContinue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _updateSubBrand;

      var _this$props, goToNextWizardStage, isLastStep, updateSubBrand, groupType, _this$state, summary, groups;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, goToNextWizardStage = _this$props.goToNextWizardStage, isLastStep = _this$props.isLastStep, updateSubBrand = _this$props.updateSubBrand, groupType = _this$props.groupType;
              _this$state = _this.state, summary = _this$state.summary, groups = _this$state.groups;

              _this.setState({
                saving: true
              });

              _context.next = 5;
              return updateSubBrand((_updateSubBrand = {}, _defineProperty(_updateSubBrand, "".concat(groupType, "Overview"), summary), _defineProperty(_updateSubBrand, groupType, groups), _updateSubBrand));

            case 5:
              _this.setState({
                saving: false
              });

              return _context.abrupt("return", isLastStep ? void 0 : void goToNextWizardStage());

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "isInitialGroupType", function (index) {
      var initialGroupTypeNames = _this.props.initialGroupTypeNames;

      if (initialGroupTypeNames && initialGroupTypeNames.length > 0) {
        return index < initialGroupTypeNames.length;
      }

      return false;
    });

    var _this$props2 = _this.props,
        _this$props2$initialG = _this$props2.initialGroupTypeNames,
        _initialGroupTypeNames = _this$props2$initialG === void 0 ? [] : _this$props2$initialG,
        _summary = _this$props2.summary,
        _groups = _this$props2.groups;

    var initialGroups = _initialGroupTypeNames.map(function (name) {
      return NEW_GROUP(name, "".concat(Date.now(), "-").concat(name));
    });

    _this.state = {
      saving: false,
      summary: _summary || '',
      groups: (0, _lodash2.default)(_groups) ? INITIAL_GROUPS(initialGroups) : _groups,
      modalVisible: false,
      modalAssetId: ''
    };
    return _this;
  }

  _createClass(WizardAssetFilesStep, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          title = _this$props3.title,
          acceptedFileTypes = _this$props3.acceptedFileTypes,
          previewType = _this$props3.previewType,
          notesPlaceholder = _this$props3.notesPlaceholder,
          inputButtonPrefix = _this$props3.inputButtonPrefix,
          _this$props3$groupTyp = _this$props3.groupTypePlaceholder,
          primaryPlaceHolder = _this$props3$groupTyp.primary,
          secondaryPlaceHolder = _this$props3$groupTyp.secondary,
          groupType = _this$props3.groupType,
          apolloClient = _this$props3.apolloClient,
          subBrandId = _this$props3.subBrandId;
      var _this$state2 = this.state,
          saving = _this$state2.saving,
          summary = _this$state2.summary,
          groups = _this$state2.groups,
          modalVisible = _this$state2.modalVisible,
          modalAssetId = _this$state2.modalAssetId;
      return _react.default.createElement("div", {
        className: "assets__container wizard-step__".concat(groupType)
      }, _react.default.createElement(_common.PageTitle, {
        title: title
      }), _react.default.createElement("section", null, _react.default.createElement(_commonReact.ManageAssetModal, {
        assetId: modalAssetId,
        isVisible: modalVisible,
        apiClient: apolloClient,
        onClose: this.closeModal
      }), _react.default.createElement(_common.OverviewSummary, {
        iconLabel: "Overview",
        textLabel: "SUMMARY",
        placeholder: "Enter Summary",
        defaultValue: summary,
        handleChange: this.updateInputField('summary')
      })), groups.map(function (group, index) {
        return _react.default.createElement(_react.Fragment, {
          key: group.subBrandGroupId || group.key
        }, groupType === 'typefaces' && _react.default.createElement(_components.FontsStyleHelmet, {
          fontIds: group.assetIds
        }), _react.default.createElement(_common.FileInputSection, {
          group: group,
          groupType: groupType,
          updateGroup: _this2.updateGroup(index),
          deleteGroup: _this2.deleteGroup(index),
          openAssetModal: _this2.openModal,
          placeHolder: index === 0 ? primaryPlaceHolder : secondaryPlaceHolder,
          acceptedFileTypes: acceptedFileTypes,
          buttonPrefix: inputButtonPrefix,
          notesPlaceholder: notesPlaceholder,
          type: previewType,
          isEditableTitle: !_this2.isInitialGroupType(index),
          isRemovable: !_this2.isInitialGroupType(index) && index !== 0,
          subBrandId: subBrandId
        }));
      }), _react.default.createElement("div", {
        className: "assets__container__new-section"
      }, _react.default.createElement(_uiKit.LinkButton, {
        onClick: this.addGroup
      }, "Tap to add New Section")), _react.default.createElement("section", null, _react.default.createElement(_uiKit.Button, {
        className: "assets__container__save-continue",
        onClick: this.handleSaveAndContinue,
        busy: saving
      }, "Save & Continue")));
    }
  }]);

  return WizardAssetFilesStep;
}(_react.Component);

var _default = WizardAssetFilesStep;
exports.default = _default;